module.exports = __webpack_public_path__ + "img/loading-articles.8514ec1a.gif";